import {generalRequest} from "../services";

export async function apiPostStartExam(formId) {
    return generalRequest.post(`student/forms/${formId}/start`)
}

export async function apiGetExamDetail(formId, formAnswerId, params) {
    const query = new URLSearchParams(params);
    const str = query.toString();
    return generalRequest.get(`student/forms/${formId}/items-answer/${formAnswerId}?`+ str)
}


export async function apiGetExamMyAnswerDetail(formId, runnerId) {
    return generalRequest.get(`student/forms/${formId}/my-answer-runner/${runnerId}`);
}



export async function apiPostAnswers(formId,formAnswerId,data) {
    return generalRequest.post(`student/forms/${formId}/answers/${formAnswerId}`,data)
}